import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
  subscribeToPush, 
  unsubscribeFromPush, 
  clearError
} from '../slice/pushSlice';

const WebNotificationSetting = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const pushState = useSelector((state) => state.push) || {};
  
  const {
    isSubscribed = false,
    isSubscribing = false,
    isUnsubscribing = false,
    isSupported = false,
    vapidPublicKey = null,
    error = null
  } = pushState;

  // Handle notification toggle
  const handleToggle = async () => {
    if (!isSupported || !user) return;

    if (isSubscribed) {
      // Unsubscribe
      const subscription = pushState.subscription;
      if (subscription) {
        try {
          await subscription.unsubscribe();
          dispatch(unsubscribeFromPush({ endpoint: subscription.endpoint }));
        } catch (error) {
          console.error('Error unsubscribing:', error);
        }
      }
    } else {
      // Subscribe
      try {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
          alert('Please allow notifications in your browser settings');
          return;
        }

        const registration = await navigator.serviceWorker.ready;
        const pushSubscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
        });

        const subscriptionData = {
          subscription: {
            endpoint: pushSubscription.endpoint,
            keys: {
              p256dh: arrayBufferToBase64(pushSubscription.getKey('p256dh')),
              auth: arrayBufferToBase64(pushSubscription.getKey('auth'))
            }
          },
          deviceInfo: getDeviceInfo(),
          userAgent: navigator.userAgent
        };

        dispatch(subscribeToPush(subscriptionData));
      } catch (error) {
        console.error('Error subscribing:', error);
      }
    }
  };

  // Helper functions
  const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  };

  const arrayBufferToBase64 = (buffer) => {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    bytes.forEach(byte => binary += String.fromCharCode(byte));
    return window.btoa(binary);
  };

  const getDeviceInfo = () => {
    const ua = navigator.userAgent;
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    let browser = 'Unknown';
    if (ua.includes('Chrome')) browser = 'Chrome';
    else if (ua.includes('Firefox')) browser = 'Firefox';
    else if (ua.includes('Safari')) browser = 'Safari';
    else if (ua.includes('Edge')) browser = 'Edge';
    
    let os = 'Unknown';
    if (ua.includes('Windows')) os = 'Windows';
    else if (ua.includes('Mac OS')) os = 'macOS';
    else if (ua.includes('Linux')) os = 'Linux';
    else if (ua.includes('Android')) os = 'Android';
    else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';
    
    return `${browser} on ${os}${isMobile ? ' (Mobile)' : ' (Desktop)'}`;
  };

  const isDisabled = isSubscribing || isUnsubscribing || !isSupported || !user || !vapidPublicKey;
console.log("isDisabled:", isDisabled, {
  isSubscribing,
  isUnsubscribing,
  isSupported,
  user,
  vapidPublicKey
});
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 16px',
      borderBottom: '1px solid #eee',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      opacity: isDisabled ? 0.6 : 1
    }}
    onClick={!isDisabled ? handleToggle : undefined}>
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span style={{ fontSize: '18px' }}>🔔</span>
        <div>
          <div style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
            Push Notifications
          </div>
          <div style={{ fontSize: '12px', color: '#666' }}>
            {isSubscribing ? 'Enabling...' :
             isUnsubscribing ? 'Disabling...' :
             isSubscribed ? 'Get real-time updates' : 'Enable notifications'}
          </div>
        </div>
      </div>

      {/* Toggle Switch */}
      <div style={{
        background: isSubscribed ? '#4CAF50' : '#ccc',
        borderRadius: '12px',
        width: '44px',
        height: '24px',
        position: 'relative',
        transition: 'background 0.2s ease'
      }}>
        <div style={{
          width: '18px',
          height: '18px',
          borderRadius: '50%',
          background: 'white',
          position: 'absolute',
          top: '3px',
          left: isSubscribed ? '23px' : '3px',
          transition: 'left 0.2s ease',
          boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
        }}></div>
      </div>
    </div>
  );
};

export default WebNotificationSetting;
